(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalLongDateFilter', [RfGlobalLongDateFilterFn]);

    // long-date filter (day-name, day, month-name, year), uses moment.locale (set on login)
    function RfGlobalLongDateFilterFn() {
        function filter(date) {
            if (date) {
                var dateMoment = moment(date);
                return dateMoment.format('dddd') + ', ' + dateMoment.format('LL');
            }
            return date;
        }

        // result depends on the global moment locale, not only on the input: without this angular
        // only re-evaluates the filter when the date changes and keeps showing the previous language
        filter.$stateful = true;

        return filter;
    }
})();